export default __webpack_public_path__ + "static/media/logo.78943b2b.svg";